<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card h-100">
      <details :open="open">
        <summary>
          <div class="card-header px-3 py-2 bg-gradient-warning">
            <h6 class="mb-0 text-capitalize text-white">ویرایش دسترسی‌ها</h6>
          </div>
        </summary>
        <div class="card-body pt-2">
          <div class="table-responsive p-0">
            <table class="table align-items-center justify-content-center mb-0">
              <thead>
                <tr>
                  <th class="text-center ">عنوان</th>
                  <th class="text-center ">مجوز مشاهده</th>
                  <th class="text-center ">مجوز افزودن</th>
                  <th class="text-center ">مجوز ویرایش</th>
                  <th class="text-center ">مجوز حذف</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in basePermissions" style="border-width: 1px 0px;">
                  <td :class="{ 'bg-gradient-light text-center': item.code == 0, 'text-end': item.code > 0 }" style="border-width: 0 !important;">
                    <b>{{ item.permissionTitle }}</b>
                  </td>
                  <td class="align-middle text-center" style="border-width: 0 !important;">
                    <div v-if="item.view" class="form-check">
                      <input class="form-check-input float-none" type="checkbox" v-model="item.currentView"
                        @click="modifyPermission(index, true)">
                    </div>
                  </td>
                  <td class="align-middle text-center" style="border-width: 0 !important;">
                    <div v-if="item.insert" class="form-check">
                      <input class="form-check-input float-none" type="checkbox" v-model="item.currentInsert"
                        @click="modifyPermission(index, false)">
                    </div>
                  </td>
                  <td class="align-middle text-center" style="border-width: 0 !important;">
                    <div v-if="item.update" class="form-check">
                      <input class="form-check-input float-none" type="checkbox" v-model="item.currentUpdate"
                        @click="modifyPermission(index, false)">
                    </div>
                  </td>
                  <td class="align-middle text-center" style="border-width: 0 !important;">
                    <div v-if="item.delete" class="form-check">
                      <input class="form-check-input float-none" type="checkbox" v-model="item.currentDelete"
                        @click="modifyPermission(index, false)">
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </details>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowAccessGroupPermission",
  props: ['currentPermissions', 'open'],
  data() {
    return {
      basePermissions: [],
    }
  },
  watch: {
    currentPermissions(newValue, oldValue) {
      if (!oldValue || oldValue.length < 1) {
        this.setCurrentPermissions();
      }
    },
  },
  methods: {
    setCurrentPermissions() {
      this.basePermissions = this.basePermissions.map(x => ({ ...x, currentView: false, currentInsert: false, currentUpdate: false, currentDelete: false }));

      for (var i = 0; i < this.basePermissions.length; i++) {
        let index = this.currentPermissions.map(x => x.permissionId).indexOf(this.basePermissions[i].permissionId);

        if (index > -1) {
          let currentPermission = this.currentPermissions[index];
          this.basePermissions[i].currentView = currentPermission.view;
          this.basePermissions[i].currentInsert = currentPermission.insert;
          this.basePermissions[i].currentUpdate = currentPermission.update;
          this.basePermissions[i].currentDelete = currentPermission.delete;
        }
      }
    },
    modifyPermission(index, viewToggled) {
      setTimeout(() => {
        if (!this.basePermissions[index].currentView) {
          this.basePermissions[index].currentInsert = false;
          this.basePermissions[index].currentUpdate = false;
          this.basePermissions[index].currentDelete = false;
        }
      }, 100);

      setTimeout(() => {
        let permission = this.basePermissions[index];

        if (permission.currentView || viewToggled) {

          this.$emit('modify-permission', {
            permissionId: permission.permissionId,
            view: permission.currentView,
            insert: permission.currentInsert,
            update: permission.currentUpdate,
            delete: permission.currentDelete,
          });
        }
      }, 200);
    },
  },
  created() {
    this.basePermissions = this.$store.state.currentUserInfo.permissions;
  },
};
</script>
